import React from 'react'

export default function SavedAdmin() {
  return (
    <div>
      Admin panel for saved page
    </div>
  )
}
